import { DirectoryProtectionListProps } from "./DirectoryProtectionListItem";
import { Action } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { Section } from "@mittwald/flow-remote-react-components";
import { TextField } from "@mittwald/flow-remote-react-components";
import { Label } from "@mittwald/flow-remote-react-components";
import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Form,
  typedField,
} from "@mittwald/flow-remote-react-components/react-hook-form";
import { useEffect, useState } from "react";
import { CreateUserError } from "../../errors/CreateUserError";
import { OverlayController } from "@mittwald/flow-remote-react-components";
import { useDeclareDirectoryProtection } from "../../hooks/useDeclareDirectoryProtection";

interface FormInputs {
  description: string;
}

export const RenameDirectoryProtectionModal = (props: {
  projectId: string;
  directoryProtection: DirectoryProtectionListProps;
  controller: OverlayController;
}) => {
  const { controller } = props;

  const [errorOnSubmit, setErrorOnSubmit] = useState<Error | undefined>(
    undefined,
  );

  if (errorOnSubmit) {
    throw errorOnSubmit;
  }

  const form = useForm<FormInputs>({
    defaultValues: {
      description: props.directoryProtection.description,
    },
  });

  // Registered in an effect so the handler is added once and removed on
  // unmount (addOnClose returns the disposer).
  useEffect(
    () =>
      controller.addOnClose(() => {
        form.reset();
      }),
    [controller, form],
  );

  const declareDirectoryProtectionMutation = useDeclareDirectoryProtection(
    props.projectId,
  );

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    const result = await declareDirectoryProtectionMutation.mutateAsync({
      description: data.description,
      path: props.directoryProtection.path,
      users: props.directoryProtection.users.map((user) => user.username),
      appInstallationId: props.directoryProtection.appInstallationId,
    });

    if (result.error) {
      setErrorOnSubmit(new CreateUserError(result.error.message));
    }

    form.reset(data);
    controller.close();
  };

  const Field = typedField(form);

  return (
    <Modal controller={controller}>
      <Form form={form} onSubmit={onSubmit}>
        <Heading>
          <Text>Passwortschutz umbenennen</Text>
        </Heading>
        <Content>
          <Section>
            <Heading>Beschreibung festlegen</Heading>
            <Text>
              Gib deinem Passwortschutz einen schlüssigen Namen. Dieser wird
              später in der Übersicht und beim Aufruf des geschützten Bereichs
              angezeigt.
            </Text>

            <Field
              name="description"
              rules={{
                required: "Bitte gib eine passende Beschreibung an",
              }}
            >
              <TextField isRequired autoFocus>
                <Label>Name des Passwortschutzes</Label>
              </TextField>
            </Field>
          </Section>
        </Content>
        <ActionGroup>
          <Button
            color="success"
            type="submit"
            isPending={declareDirectoryProtectionMutation.isPending}
            isSucceeded={declareDirectoryProtectionMutation.isSuccess}
          >
            Passwortschutz umbenennen
          </Button>
          <Action
            onAction={() => {
              controller.close();
            }}
          >
            <Button color="secondary" variant="soft">
              Abbrechen
            </Button>
          </Action>
        </ActionGroup>
      </Form>
    </Modal>
  );
};
